module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-search",
    class: {
      searchDone: _vm.searchDone,
      searchSuccessful: _vm.searchSuccessful,
      searchFailed: _vm.searchFailed
    }
  }, [(!_vm.searchDone) ? _c('span', [_c('div', {
    staticClass: "top-section"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Search")]), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.closeSearchModal
    }
  }, [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.searchDone) ? _c('span', [_c('div', {
    staticClass: "_top dflex top-section"
  }, [_c('img', {
    staticClass: "_left-icon",
    attrs: {
      "src": require('@/assets/search.svg'),
      "width": "24"
    },
    on: {
      "click": _vm.resetSearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    staticClass: "_logo",
    attrs: {
      "src": require('@/assets/ys_logo_primary-black.svg'),
      "width": "130"
    }
  })]), _vm._v(" "), _c('v-icon', {
    staticClass: "min-icon",
    on: {
      "click": function($event) {
        _vm.closeSearchModal()
      }
    }
  }, [_vm._v("\n        keyboard_arrow_down\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "subsection"
  }, [(_vm.searchSuccessful) ? _c('div', {
    staticClass: "result-for"
  }, [_vm._v("Search result for:")]) : _vm._e(), _vm._v(" "), (_vm.searchFailed) ? _c('div', {
    staticClass: "result-for"
  }, [_vm._v("No search result for:")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "keyword"
  }, [_vm._v(_vm._s(_vm.searchQuery))])])]) : _vm._e(), _vm._v(" "), (_vm.searchSuccessful) ? _c('div', {
    staticClass: "results"
  }, [_c('div', {
    staticClass: "_label"
  }, [_c('div', {
    staticClass: "label-title"
  }, [_vm._v("People")]), _vm._v(" "), _c('div', {
    staticClass: "label-count"
  }, [_vm._v(_vm._s(_vm.usersResults.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "each_result user-results"
  }, _vm._l((_vm.usersResults), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "search-result user-result"
    }, [_c('user-tag', {
      attrs: {
        "user": result,
        "width": "40",
        "height": "40",
        "showAvatar": "",
        "showUserType": ""
      }
    }), _vm._v(" "), _c('user-follow-btn', {
      attrs: {
        "user": result,
        "theme": "dark"
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "each_result album-results"
  }, [_c('div', {
    staticClass: "_label"
  }, [_c('div', {
    staticClass: "label-title"
  }, [_vm._v("Music")]), _vm._v(" "), _c('div', {
    staticClass: "label-count"
  }, [_vm._v(_vm._s(_vm.albumResults.length) + " results")])]), _vm._v(" "), _vm._l((_vm.albumResults), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "search-result album-result"
    }, [_c('trackcardsimple', {
      attrs: {
        "item": result,
        "cover": result.cover.thumb.url,
        "title": result.name,
        "subtitle": result.user.username
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "each_result video-results"
  }, [_c('div', {
    staticClass: "_label"
  }, [_c('div', {
    staticClass: "label-title"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "label-count"
  }, [_vm._v(_vm._s(_vm.videoResults.length) + " results")])]), _vm._v(" "), _vm._l((_vm.videoResults), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "search-result video-result"
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": "",
        "item": result,
        "sideTabView": "",
        "hideUser": "",
        "noMeta": "",
        "showUsername": ""
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "each_result product-results"
  }, [_c('div', {
    staticClass: "_label"
  }, [_c('div', {
    staticClass: "label-title"
  }, [_vm._v("Products")]), _vm._v(" "), _c('div', {
    staticClass: "label-count"
  }, [_vm._v(_vm._s(_vm.productResults.length) + " results")])]), _vm._v(" "), _vm._l((_vm.productResults), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "search-result product-result"
    }, [_c('product-card', {
      attrs: {
        "dataObject": result,
        "sideTabView": "",
        "noMeta": "",
        "altMeta": ""
      }
    })], 1)
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.searchDone) ? _c('div', {
    staticClass: "body-section"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    attrs: {
      "type": "search",
      "id": "searchModalInput",
      "placeholder": "Start typing..",
      "disabled": _vm.isSearchLoading
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.initSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "search-loader transparent",
    attrs: {
      "ripple": false,
      "depressed": "",
      "disabled": "",
      "loading": _vm.isSearchLoading
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subsection"
  }, [_c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("Music, videos, products & people")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4e4c282","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/components/search.vue
// module id = 1847
// module chunks = 180